import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaCheck } from 'react-icons/fa';
import IconWrapper from '../components/IconWrapper';

// Animasyon için varyantlar
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const Iletisim: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    pet: '',
    subject: '',
    message: ''
  });
  
  const [formSubmitted, setFormSubmitted] = useState(false);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    // Burada form verilerini gönderme işlemi yapılabilir
    setFormSubmitted(true);
    
    // Form başarıyla gönderildikten sonra formu sıfırla
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        name: '',
        email: '',
        phone: '',
        pet: '',
        subject: '',
        message: ''
      });
    }, 3000);
  };
  
  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-primary to-primary-dark text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">
              İletişim
            </h1>
            <p className="text-xl text-blue-100">
              Sorularınız ve randevularınız için bizimle iletişime geçin
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <motion.div 
              className="bg-white p-8 rounded-2xl shadow-md text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary-light/20 flex items-center justify-center">
                <IconWrapper icon={FaPhone} className="text-2xl text-primary" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Telefon</h3>
              <p className="text-gray-600 mb-2">Bize hemen ulaşın</p>
              <a href="tel:+905533077616" className="text-primary font-medium text-lg hover:underline">
                0553 307 76 16
              </a>
            </motion.div>
            
            <motion.div 
              className="bg-white p-8 rounded-2xl shadow-md text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-secondary-light/20 flex items-center justify-center">
                <IconWrapper icon={FaClock} className="text-2xl text-secondary" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Çalışma Saatleri</h3>
              <div className="text-gray-600 space-y-1">
                <p>Pazartesi - Cuma: 09:30 - 19:30</p>
                <p>Cumartesi: 09:30 - 19:30</p>
                <p>Pazar: 11:00 - 20:00</p>
              </div>
            </motion.div>
            
            <motion.div 
              className="bg-white p-8 rounded-2xl shadow-md text-center"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-light/20 flex items-center justify-center">
                <IconWrapper icon={FaMapMarkerAlt} className="text-2xl text-accent" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-800">Adres</h3>
              <p className="text-gray-600 mb-2">Kliniğimizi ziyaret edin</p>
              <p className="text-primary font-medium text-lg">
                Demirtaş Cumhuriyet 1205 sokak<br />
                16000 Osmangazi / Bursa
              </p>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Map */}
            <motion.div
              className="rounded-xl overflow-hidden shadow-lg h-[400px] bg-gray-100"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5 }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3046.0475044176544!2d29.116552776117437!3d40.25502637146853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ca3e9c3f00a0ed%3A0x3016c5687d79780!2sDemirta%C5%9F%20Cumhuriyet%2C%201205.%20Sk.%2C%2016245%20Osmangazi%2FBursa!5e0!3m2!1str!2str!4v1709805611099!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="eager"
                referrerPolicy="no-referrer-when-downgrade"
                title="Yahşi Veteriner Kliniği Konum"
                className="rounded-xl"
              ></iframe>
            </motion.div>
            
            {/* Contact Form */}
            <motion.div 
              className="bg-white p-8 rounded-2xl shadow-md"
              variants={fadeIn}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              <h2 className="text-2xl font-display font-bold text-gray-800 mb-6">
                Bize Mesaj Gönderin
              </h2>
              
              {formSubmitted ? (
                <div className="bg-green-50 text-green-700 p-4 rounded-lg mb-6 flex items-center">
                  <IconWrapper icon={FaCheck} className="mr-2 text-green-500" />
                  <span>Mesajınız başarıyla gönderildi. En kısa sürede size dönüş yapacağız.</span>
                </div>
              ) : null}
              
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-1">
                      Adınız Soyadınız*
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-1">
                      E-posta*
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-1">
                      Telefon Numaranız*
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="pet" className="block text-gray-700 font-medium mb-1">
                      Evcil Hayvanınız
                    </label>
                    <select
                      id="pet"
                      name="pet"
                      value={formData.pet}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                    >
                      <option value="">Lütfen Seçin</option>
                      <option value="Kedi">Kedi</option>
                      <option value="Köpek">Köpek</option>
                      <option value="Kuş">Kuş</option>
                      <option value="Kemirgen">Kemirgen</option>
                      <option value="Diğer">Diğer</option>
                    </select>
                  </div>
                </div>
                
                <div>
                  <label htmlFor="subject" className="block text-gray-700 font-medium mb-1">
                    Konu*
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-1">
                    Mesajınız*
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows={5}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary"
                    required
                  ></textarea>
                </div>
                
                <div>
                  <button
                    type="submit"
                    className="px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-primary-dark transition-colors duration-300"
                  >
                    Mesaj Gönder
                  </button>
                </div>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Iletisim; 